"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nyanEgg = {
    name: "nyan",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["n", "y", "a", "n"],
    },
    stopTrigger: {
        type: "keys",
        keystrokes: ["Escape"],
    },
    resources: [
        {
            type: "css",
            url: "https://kyco.github.io/eeaas/example-nyancat.css",
        },
        {
            type: "script",
            url: "https://kyco.github.io/eeaas/example-nyancat.js",
        },
    ],
    onStart: function () {
        // @ts-expect-error does not exist on window
        window.launchNyanCat();
    },
    onStop: function () {
        // @ts-expect-error does not exist on window
        window.cleanupNyanCat();
    },
};
exports.default = nyanEgg;
